import { render, staticRenderFns } from "./ProjectDetail.vue?vue&type=template&id=29d30cfd&scoped=true&"
import script from "./ProjectDetail.vue?vue&type=script&lang=js&"
export * from "./ProjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetail.vue?vue&type=style&index=0&id=29d30cfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d30cfd",
  null
  
)

export default component.exports